import React from 'react';
import { HashRouter as Router, Route, Routes, Navigate, Outlet } from "react-router-dom";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Importa os Provedores de Contexto
import { AuthProvider, useAuth } from './Context/AuthContext'; 
import { CalcLeiteProvider } from './screens/Calcleite/CalcleiteContext';
import { CalcCafeProvider } from '../src/screens/Calccafe/CalccafeContext'; // <-- NOVA IMPORTAÇÃO

// Componentes e Telas Públicas
import Header from "./components/Header";
import Home from "./screens/Home/Home";
import Login from "./screens/Login/Login";
import Register from "./screens/cadastro/Register";
import Conta from "./screens/Conta/Conta";
import Perfil from "./screens/Perfil/Perfil";
import SobreNos from "./screens/Sobre/Sobre";
import PoliticaPrivacidade from './screens/PoliticaPrivacidade/PoliticaPrivacidade';
import Contatos from "./screens/Contatos/Contatos";
import VerificarEmail from '../src/screens/verificarEmail/VerificarEmail';
import AuthRedirect from '../src/screens/authRedirect/AuthRedirect';

// Telas de Vitrine dos Apps
import Calcleite from "./screens/Calcleite/Calcleite";
import CalcCafe from "./screens/Calccafe/Calccafe";
import CalcBov from "./screens/Calcbov/Calcbov";
import CalcAgro from "./screens/Calcagro/Calcagro";

// Telas do Fluxo de Assinatura
import MostruarioApps from '../src/screens/mostruarioApps/MostruarioApps';
import Planos from './screens/Planos/Planos';
import Pagamento from './screens/Pagamento/Pagamento';

// Telas INTERNAS e PROTEGIDAS dos Apps
import CalcleiteMain from './screens/Calcleite/CalcleiteMain';
import Instrucoes from '../src/screens/Calcleite/Instrucoes';
import Producao from './screens/Calcleite/Producao';
import Capital from './screens/Calcleite/Capital';
import Custos from './screens/Calcleite/Custos';
import Receita from './screens/Calcleite/Receita';
import Relatorio from './screens/Calcleite/Relatorio';
import CalcCafeMain from './screens/Calccafe/CalccafeMain'; // <-- NOVA IMPORTAÇÃO
import InstrucoesCafe from './screens/Calccafe/InstrucoesCafe';
import ProducaoCafe from './screens/Calccafe/ProducaoCafe';
import CapitalCafe from './screens/Calccafe/CapitalCafe';
import CustosCafe from './screens/Calccafe/CustosCafe';
import ReceitaCafe from './screens/Calccafe/ReceitaCafe';
import RelatorioCafe from './screens/Calccafe/RelatorioCafe';
import TermosDeUso from './screens/Terms/Terms';
// #####################################################################
// ## CONFIGURAÇÕES E COMPONENTES AUXILIARES ##
// #####################################################################

const stripePublishableKey = "pk_live_51RHohNKQvAHz3rPLDUxoj9mJnKkjZDy2Nb8UVUWwTUXwGi0T80ql0WPZS25X07lo4atl48g7NOVEliDkO7jKnXjO00LADTdeI0";
const stripePromise = loadStripe(stripePublishableKey);

const StripeLayout = () => ( <Elements stripe={stripePromise}><Outlet /></Elements> );

const ProtectedRoute = ({ children, app }) => {
  const { user, userData, loading } = useAuth();
  if (loading) { return <div>Carregando sua sessão...</div>; }
  if (!user) { return <Navigate to="/login" />; }
  if (user && !user.emailVerified) { return <Navigate to="/verificar-email" state={{ email: user.email }} />; }
  if (app) {
    if (userData && userData[app]) {
      return children;
    } else {
      return <Navigate to={`/planos/${app}`} />;
    }
  }
  return children;
};

// Componente de layout para as rotas do CalcLeite
const CalcLeiteRoutes = () => (
    <CalcLeiteProvider>
        <Outlet />
    </CalcLeiteProvider>
);

// --- COMPONENTE DE ROTAS PARA O CALCCAFÉ (CORRIGIDO) ---
// Ele agora usa <Outlet /> para renderizar as rotas filhas, assim como o do CalcLeite.
const CalcCafeRoutes = () => (
    <CalcCafeProvider>
        <Outlet />
    </CalcCafeProvider>
);


// #####################################################################
// ## COMPONENTE PRINCIPAL APP ##
// #####################################################################

function App() {
  return (
    <AuthProvider>
      <Router>
        <Header />
        <Routes>
          {/* --- Rotas Públicas e de Conteúdo --- */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verificar-email" element={<VerificarEmail />} />
          <Route path="/auth-redirect" element={<AuthRedirect />} />
          <Route path="/sobre" element={<SobreNos />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/contatos" element={<Contatos />} />
          <Route path="/termos" element={<TermosDeUso />} />
          
          {/* --- Rotas de Vitrine dos Apps --- */}
          <Route path="/calcleite" element={<Calcleite />} />
          <Route path="/calccafe" element={<CalcCafe />} />
          <Route path="/calcbov" element={<CalcBov />} />
          <Route path="/calcagro" element={<CalcAgro />} />

          {/* --- Rotas do Fluxo de Assinatura --- */}
          <Route path="/assinar" element={<MostruarioApps />} />
          <Route path="/planos/:appKey" element={<Planos />} />
          
          <Route element={<StripeLayout />}>
            <Route path="/:appKey/pagamento" element={<Pagamento />} />
          </Route>

          {/* --- Rotas Protegidas Genéricas --- */}
          <Route path="/conta" element={<ProtectedRoute><Conta /></ProtectedRoute>} />
          <Route path="/perfil" element={<ProtectedRoute><Perfil /></ProtectedRoute>} />

          {/* --- ROTAS PROTEGIDAS DO APP CALCLEITE --- */}
          <Route 
            path="/calcleite/app" // Caminho base
            element={
              <ProtectedRoute app="calcleite">
                <CalcLeiteRoutes />
              </ProtectedRoute>
            } 
          >
            <Route index element={<CalcleiteMain />} />
            <Route path="instrucoes" element={<Instrucoes />} />
            <Route path="producao" element={<Producao />} />
            <Route path="capital" element={<Capital />} />
            <Route path="custos" element={<Custos />} />
            <Route path="receita" element={<Receita />} />
            <Route path="relatorio" element={<Relatorio />} />
          </Route>

          {/* --- ROTAS PROTEGIDAS DO APP CALCCAFÉ (CORRIGIDO) --- */}
          <Route 
            path="/calccafe/app" // Caminho base
            element={
              <ProtectedRoute app="calccafe">
                <CalcCafeRoutes />
              </ProtectedRoute>
            }
          >
            <Route index element={<CalcCafeMain />} />
            <Route path="instrucoesCafe" element={<InstrucoesCafe />} />
            <Route path="producao" element={<ProducaoCafe />} />
            <Route path="capitalCafe" element={<CapitalCafe />} />
            <Route path="custosCafe" element={<CustosCafe />} />
            <Route path="receitaCafe" element={<ReceitaCafe />} />
            <Route path="relatorioCafe" element={<RelatorioCafe />} />
            {/* Adicione as futuras rotas do CalcCafé aqui */}
          </Route>

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

